export const englishTranslations = {
  HomePage: {
    MainHeader: "24/7 Dedicated Support",
    SubHeader:
      "Our dedicated team of experts is ready to provide you with prompt and reliable support, ensuring that your concerns are addressed swiftly.",
    OpenTicketButton: "Open A Ticket",
    CustomerSupport: "Customer Support",
    ModuleOne: {
      title: "Expert Guidance, Every Step of the Way",
      body: "Benefit from our wealth of knowledge and experience to navigate any issue seamlessly.",
    },
    ModuleTwo: {
      title: "Tailored Solutions for Your Needs",
      body: "Our support services are adaptable and personalized, ensuring that you receive solutions tailored specifically to your requirements.",
    },
    ModuleThree: {
      title: "Reliability and Trustworthiness",
      body: "Our support is delivered with the utmost reliability and security, providing you with the confidence you need to focus on what matters most.",
    },
    HowToCreateTicket: "How to Create a Ticket",
    StepOne:
      'Register and login to your account. Go to the "My Tickets" tab and click “New Ticket” to create your ticket',
    StepTwo:
      "Please wait while one of our staff responds, this process may take a while. Afterwards, we will provide you with more details on how to fix your issue",
    StepThree:
      "After a response from our side, we can finally get to fixing the issue by assigning a technical support member to assist you remotely or on-site.",
    GetStarted: "Get Started",
    Step: "STEP",
  },
  Footer: {
    WhatWeDo: "WHAT WE DO",
    WhatWeDoBody:
      "Apart from project consultancy, installation and post-installation services, we also provide TDM/IP PBX and Call Center solutions, fiber optic cabling, termination and testing services, and sales and after-sales support of network and transmission equipment.",
    Contact: "CONTACT",
    FollowUs: "FOLLOW US",
    Copyright: "Copyright",
  },
  AccountInfoPage: {
    AccountInfo: "Account Info",
    HeaderSubtitle: "Manage your account information",
    Name: "Name",
    Username: "Username",
    Email: "Email",
    Phone: "Phone",
    Company: "Company",
    Role: "Role",
    AccountStatus: "Account Status",
    Activated: "Activated",
    Inactive: "Inactive",
    PersonalDetails: "Personal Details",
    Security: "Security",
    MultiFactorAuthentication: "Multi-Factor Authentication",
    EmailAuthentication: "Email Authentication",
    Authenticator: "Authenticator",
    AuthenticatorApp: "Authenticator App",
    ChangeYourPassword: "Change your password?",
    ClickHere: "Click here",
    Cancel: "Cancel",
    Save: "Save",
  },
  ForgotPasswordPage: {
    RequestCode: "Request Code",
    SubmitCode: "Submit Code",
    ChangeYourPassword: "Change your password",
    ForgotYourPassword: "Forgot your password?",
    ResetPasswordBody:
      "Please enter your email so we can send you a reset password code",
    Code: "Code",
    EmailAddress: "Email Address",
    CheckYourCode:
      "We have sent you a confirmation code. Please check your email and enter the code.",
    ConfirmationCode: "Confirmation Code",
    NewPassword: "New Password",
    BackToAccountInfo: "Back To Account Info",
    BackToLogin: "Back To Login",
    ChangePassword: "Change Password",
    DidntGetCode: "Didn't get a code?",
    TryAgain: "Try Again",
    SecondsLeft: "in {{seconds}}s",
  },
  Navigation: {
    Home: "Home",
    AllTickets: "All Tickets",
    MyTickets: "My Tickets",
    Management: "Management",
    AccountInfo: "Account Info",
    ChangePassword: "Change Password",
    Logout: "Logout",
    Dashboard: "Dashboard",
    Tickets: "Tickets",
    Storage: "Storage",
    Users: "Users",
    Departments: "Departments",
    Security: "Security",
    Logs: "Logs",
    Settings: "Settings",
    Login: "Login",
    Register: "Register",
    ForgotPassword: "Forgot Password",
    Products: "Products",
    DarkTheme: "Dark Theme",
    LightTheme: "Light Theme",
    Business: "Business",
  },
  Business: {
    Companies: "Companies",
    Contacts: "Contacts",
    Products: "Products",
  },
  Company: {
    Companies: "Companies",
    Company: "Company",
    CreateCompany: "Create Company",
    NewCompany: "New Company",
    Name: "Name",
    RegNo: "RegNo",
    Emails: "Emails",
    Phones: "Phones",
    ExtRef: "ExtRef",
    Contacts: "Contacts",
    NamePlaceholder: "ex. ABC Ltd.",
    RegNoPlaceholder: "ex. 11223344-aabbccdd",
    ExtRefPlaceholder: "ex. EC33499...",
    EditCompany: "Edit Company",
    DeleteCompany: "Delete Company",
  },
  Address: {
    Address: "Address",
    Name: "Name",
    Line1: "Line1",
    Line2: "Line2",
    City: "City",
    State: "State",
    PostalCode: "PostalCode",
    Country: "Country",
    Geo: "Geo",
    Lat: "Lat",
    Long: "Long",
    Delete: "Delete",
  },
  Contact: {
    Contacts: "Contacts",
    Contact: "Contact",
    Company: "Company",
    CreateContact: "Create Contact",
    NewContact: "New Contact",
    Title: "Title",
    FirstName: "First Name",
    MiddleName: "Middle Name",
    LastName: "Last Name",
    Name: "Name",
    Email: "Email",
    Phones: "Phones",
    Address: "Address",
    Position: "Position",
    ExtRef: "ExtRef",
    EditContact: "Edit Contact",
    DeleteContact: "Delete Contact",
  },
  CompanyContacts: {
    CompanyContacts: "Company Contacts",
  },
  ManageTicketPage: {
    Ticket: "Ticket",
  },
  CreateTicketPage: {
    CreateTicket: "Create Ticket",
  },
  SetupPage: {
    Setup: "Setup",
    Finish: "Finish",
    FullName: "Full name",
    Email: "Email",
    Username: "Username",
    Password: "Password",
    Finalize: "Finalize",
    ScanQrGuide:
      "Please scan the QR code on the authenticator app to login to the administrator",
    GoBack: "Go Back",
    Features: "Features",
    Back: "Back",
    Next: "Next",
    EmailSetup: {
      EmailSetup: "Email Setup",
      Server: "Server",
      From: "From",
      Username: "Username",
      Password: "Password",
      Port: "Port",
      Secure: "Secure",
    },
    FtpSetup: {
      FTPSetup: "FTP Setup",
      Host: "Host",
      Username: "Username",
      Password: "Password",
      Port: "Port",
      Secure: "Secure",
      UploadPath: "Upload Path",
    },
    OpenAISetup: {
      OpenAISetup: "Open AI Setup",
      ApiKey: "Api Key",
      AssistantID: "Assistant ID",
      OrganizationID: "Organization ID",
    },
  },
  LoginForm: {
    Header: "Welcome",
    Subheader: "Please login to your account here!",
    LoginInput: {
      label: "Login",
      placeholder: "Username or Email",
    },
    Password: "Password",
    DontHaveAccount: "Don't have an account yet?",
    Register: "Register",
    Login: "Login",
    ForgotPassword: "Forgot password?",
  },
  ActivateAccountDialog: {
    ActivateYourAccount: "Activate your account",
    PleaseEnterCode:
      "Please enter the 6-digit code that was sent to your email. The code is valid for 24 hours; trying to sign in again sends a fresh one. Earlier letter codes are also accepted.",
    ActivationCode: "Activation Code",
    Cancel: "Cancel",
    Activate: "Activate",
  },
  OTPDialog: {
    OneTimePassword: "One-time password",
    PleaseEnterOtp:
      "Please enter the one-time password from your authenticator app",
    OtpCode: "OTP Code",
    Cancel: "Cancel",
    Confirm: "Confirm",
  },
  EmailConfirmationDialog: {
    EmailConfirmation: "Email Confirmation",
    PleaseEnterCode: "Please enter the code that was sent to your email",
    ConfirmationCode: "Confirmation Code",
    Cancel: "Cancel",
    Confirm: "Confirm",
  },
  RegisterForm: {
    Register: "Register",
    ToContactOurSupport:
      "To contact our support and make a ticket please sign up here.",
    Email: "Email",
    Company: "Company",
    Phone: {
      Label: "Phone",
      Placeholder: "Phone number",
    },
    Name: {
      Label: "Name",
      Placeholder: "ex. John Doe",
    },
    Username: {
      Label: "Username",
      Placeholder: "ex. johndoe",
    },
    Password: "Password",
    AlreadyHaveAccount: "Already have an account?",
    Login: "Login",
  },
  NotificationButton: {
    LoadMore: "Load more...",
    Notifications: "Notifications",
    ClearNotifications: "Clear Notifications",
    NoNotificationsFound: "No notifications found",
  },
  UploadButton: {
    Upload: "Upload",
  },
  ImageUploadButton: {
    Upload: "Upload",
    Change: "Change",
    ClickToUpload: "Click here to upload your image",
    ImgSupported: "Supports: PNG, JPG, JPEG, WEBP",
  },
  UploadDialog: {
    Upload: "Upload",
    UploadAttachments: "Upload Attachments",
    ClickToUpload: "Click to upload",
  },
  TaskDialog: {
    Save: "Save",
    Title: "Title",
    TaskType: "Task Type",
    TaskTypePlaceholder: "Select task type",
    Time: "Time",
    Add: "Add",
    DeleteTask: "Delete Task",
    Description: "Description",
    Times: "Times",
    Assignees: "Assignees",
    NoTimelogYet: "No timelog yet",
    NoAssigneesYet: "No assignees yet",
    ItemsUsed: "Items Used",
    NoItemsYet: "No items yet",
    Name: "Name",
    Action: "Action",
    SelectUserPlaceholder: "Select user to assign...",
    Comments: {
      Label: "Comments",
      Placeholder: "ex. Task needs re-evaluation at time X",
    },
    CancelTask: "Cancel Task",
    Delete: "Delete",
    Start: "Start",
    Stop: "Stop",
    AlreadyStarted: "Already Started?",
    StartAndEndDates: "Start & End Dates",
    Set: "Set",
    StartDate: "Start Date",
    EndDate: "End Date",
  },
  TaskTimelogChip: {
    Edit: "Edit",
    Cancelled: "Cancelled",
    Duration: "Duration",
    InProgress: "In Progress",
    StartTime: "Start Time",
    EndTime: "End Time",
  },
  DateDialog: {
    StartAndEndDates: "Start And End Dates",
    Set: "Set",
    StartDate: "Start Date",
    EndDate: "End Date",
  },
  QRButton: {
    QR: "QR",
    PleaseScan: "Please scan the QR code in your authenticator application",
    Close: "Close",
    ViewQrCode: "View Qr Code",
  },
  FilterLabels: {
    Ticket: {
      ID: "ID",
      Department: "Department",
      Company: "Company",
      Title: "Title",
      Status: "Status",
      Date: "Date",
      Priority: "Priority",
      City: "City",
      Location: "Location",
      CallID: "Call ID",
      Person: "Person",
      Assignee: "Assignee",
      ExtRef: "External Ref.",
    },
    Users: {
      Name: "Name",
      Email: "Email",
      Phone: "Phone",
      Company: "Company",
      Username: "Username",
      Role: "Role",
      ExtRef: "External Ref.",
    },
    Firewall: {
      Type: "Type",
      IP: "IP",
      Prefix: "Prefix Length",
      Date: "Date",
    },
    Items: {
      Description: "Description",
      Date: "Date",
      Type: "Type",
      LocationDescription: "Location description",
    },
    Subscription: {
      Invoice: "Invoice",
      Code: "Code",
      Date: "Date",
    },
    Logs: {
      Date: "Date",
      Username: "Username",
      User: "User",
      Model: "Model",
    },
    Department: {
      Name: "Name",
      Description: "Description",
      Administrative: "Administrative",
      Date: "Date",
    },
    Products: {
      Name: "Name",
      ItemCode: "Item Code",
      Group: "Group",
      Price: "Price",
      QuantityInStock: "Quantity In Stock",
      AmountUsed: "Amount Used",
      Currency: "Currency",
      ExtRef: "External Ref.",
    },
    Company: {
      Name: "Name",
      RegNo: "RegNo",
      Emails: "Emails",
      Phones: "Phones",
      ExtRef: "ExtRef",
    },
    Contact: {
      Title: "Title",
      FirstName: "FirstName",
      MiddleName: "MiddleName",
      LastName: "LastName",
      Email: "Email",
      Phones: "Phones",
      Position: "Position",
      Address: {
        City: "City",
        PostalCode: "Postal Code",
        Country: "Country",
      },
      ExtRef: "ExtRef",
    },
  },
  OperatorSelector: {
    eq: "is equal to",
    gt: "is greater than",
    lt: "is less than",
    ne: "is not equal to",
    gte: "is greater or equal",
    lte: "is less or equal",
    regex: "contains",
  },
  FilterBox: {
    ResetAll: "Reset All",
    Apply: "Apply",
    AddFilter: "Add Filter",
    Filters: "Filters",
    AdvancedFilters: "Advanced filters",
    From: "From",
    To: "To",
    SortBy: "Sort By",
    OrderBy: "Order By",
    Ascending: "Asc",
    Descending: "Desc",
    SavedViews: "Saved views",
  },
  CardList: {
    NoResultsFound: "No results found",
  },
  DataTable: {
    NoResultsFound: "No results found",
    MaxRows: "Max rows",
    DisplayedRows: "{{info.from}}–{{info.to}} of {{info.count}}",
  },
  CreateUserDialog: {
    CreateUser: "Create User",
    Role: "Role",
    Email: {
      Label: "Email",
      Placeholder: "ex. john.doe@email.com",
    },
    Username: "Username",
    Company: "Company",
    Phone: "Phone",
    FullName: "Full Name",
    Password: "Password",
    EmailConfirmation: "Email Confirmation",
    OTPEnabled: "OTP Enabled",
    ExtRef: "External Ref.",
    ExtRefPlaceholder: "ex. EC33499...",
  },
  CreateRecordDialog: {
    CreateRecord: "Create Record",
    Type: "Type",
    IP: {
      Label: "IP Address (IPv4 or IPv6)",
      Placeholder: "ex. 192.168.0.1 or 2001:db8::1",
    },
    Prefix: {
      Label: "Prefix Length",
      Placeholder: "ex. 32 for a single IPv4, 128 for a single IPv6, 24 for a /24",
    },
  },
  EditRecordDialog: {
    EditRecord: "Edit Record",
    DeleteRecord: "Delete Record",
    Type: "Type",
    IP: {
      Label: "IP Address (IPv4 or IPv6)",
      Placeholder: "ex. 192.168.0.1 or 2001:db8::1",
    },
    Prefix: {
      Label: "Prefix Length",
      Placeholder: "ex. 32 for a single IPv4, 128 for a single IPv6, 24 for a /24",
    },
  },
  ItemList: {
    NewPlaceholder: "New Item",
  },
  CreateDepartmentDialog: {
    CreateDepartment: "Create Department",
    Name: "Name",
    Description: "Description",
    Administrative: "Administrative",
  },
  Atoms: {
    AskAiTooltip: "Ask AI",
    DeleteTooltip: "Delete",
    SummarizeTooltip: "Summarize",
    TranslateTooltip: "Translate",
  },
  AskAiDialog: {
    Description:
      "You can edit the content to remove any private information before confirming.",
    PromptLabel: "Prompt",
    Cancel: "Cancel",
    AskAI: "Ask AI",
  },
  AskAiResponseDialog: {
    AIResponse: "AI Response",
  },
  DateRanges: {
    Week: "Week",
    Month: "Month",
    Year: "Year",
    AllTime: "All Time",
  },
  EditButton: {
    Tooltip: "Edit",
    Save: "Save",
    Cancel: "Cancel",
  },
  FormInput: {
    True: "True",
    False: "False",
    ColorTooltip: "Pick a Color",
  },
  Dashboard: {
    ActiveTasks: "Active Tasks",
    Tickets: "Tickets",
    View: "View",
    NoActiveTasks: "There are no active tasks",
    TicketStatus: "Ticket Status",
    TicketsResolved: "Tickets Resolved",
    UnsolvedTickets: "Unsolved Tickets",
    PendingTickets: "Pending Tickets",
    SolvedTickets: "Solved Tickets",
    AvgResponseTime: "Avg. Response Time",
    AvgResolutionTime: "Avg. Resolution Time",
  },
  Ticket: {
    ResponseEmpty: "You must enter text or upload a file in your response",
    MustSelectDepartment: "You must select a department first",
    Assignees: "Assignees",
    NoAssigneesYet: "No Assignees Yet",
    Placeholder: "Please select a user to assign",
    NoServiceCall: "There is no service call",
    NoTasks: "There are no tasks",
    MyTickets: "My Tickets",
    CreateTask: "Create Task",
    CreateServiceCall: "Create Service Call",
    AttachServiceCall: "Attach Service Call",
    Title: "Title",
    Description: "Description",
    DescriptionPlaceholder: "ex. Rearrange the boxes by color order",
    TaskType: "Task Type",
    ServiceCallTitle: "Service Call Title",
    ProblemType: "Problem Type",
    CallType: "Call Type",
    Priority: "Priority",
    Customer: "Customer",
    ContactInfo: "Contact Info",
    Contact: "Contact",
    Technician: "Technician",
    Search: "Search",
    SearchPlaceholder: "Search...",
    Response: "Response",
    ResponsePlaceholder: "New Response",
    Attachments: "Attachments",
    PrivateResponse: "Private",
    NoFilesSelected: "No Files Selected",
    Upload: "Upload",
    Clear: "Clear",
    Respond: "Respond",
    Send: "Send",
    TitlePlaceholder: "Broken Item No. 123",
    NewTitlePlaceholder: "New Title",
    Details: "Details",
    DetailsPlaceholder: "Ticket details",
    AIFeatures: "AI Features",
    Company: "Company",
    CompanyName: "Company Name",
    ContactPerson: "Contact Person",
    CompanyPlaceholder: "Your company",
    Department: "Department",
    DepartmentPlaceholder: "Choose a department",
    City: "City",
    CityPlaceholder: "City name",
    Location: "Location",
    LocationPlaceholder: "Address...",
    Status: "Status",
    Update: "Update",
    ServiceCall: "Service Call",
    Expenses: "Expenses",
    ItemNo: "Item No.",
    SerialNo: "Serial No.",
    Quantity: "Quantity",
    Times: "Times",
    Duration: "Duration",
    Remarks: "Remarks",
    Workers: "Workers",
    View: "View",
    EditContent: "Edit Content",
    Create: "Create",
    Attach: "Attach",
    Voucher: "Voucher",
    AddVoucher: "Add voucher",
    CreateTicket: "Create Ticket",
    Tasks: "Tasks",
    Tickets: "Tickets",
    NewTicket: "New Ticket",
    Person: "Person",
    Phone: "Phone",
    PhonePlaceholder: "Phone number",
    ID: "ID",
    Date: "Date",
    ServiceCallNumber: "Call ID",
    ServiceCallID: "Service Call ID",
    NotAvailable: "Not Available",
    Action: "Action",
    Manage: "Manage",
    Name: "Name",
    Cellular: "Cellular",
    Tel1: "Tel1",
    Tel2: "Tel2",
    Email: "Email",
    SapContact: "Sap Contact",
    Save: "Save",
    Cancel: "Cancel",
    Edit: "Edit",
    Translate: "Translate",
    Summarize: "Summarize",
    AskAI: "AskAI",
    Delete: "Delete",
    ShowOriginal: "Show Original",
    ExtRef: "External Ref.",
    ExtRefPlaceholder: "ex. EC33499...",
  },
  Product: {
    Products: "Products",
    NewProduct: "New Product",
    ItemCode: "Code",
    Name: "Name",
    Group: "Group",
    Price: "Price",
    Currency: "Currency",
    QuantityInStock: "Quantity In Stock",
    Manage: "Manage",
    CreateProduct: "Create Product",
    EditProduct: "Edit Product",
    AmountUsed: "Amount Used",
    Total: "Total",
    WarehouseInfo: "Warehouse Info",
    DeleteProduct: "Delete Product",
    Cancel: "Cancel",
    Select: "Select",
    Quantity: "Quantity",
    ProductsUsed: "Products Used",
    NoItemsYet: "No items yet",
    Serials: "Serials",
    NoSerialsAdded: "No serials added",
    ExtRef: "External Ref.",
  },
  Department: {
    Users: "Users",
    NoUserAssigned: "No users assigned to this department yet",
    Departments: "Departments",
    Action: "Action",
    Edit: "Edit",
    Delete: "Delete",
    Name: "Name",
    Description: "Description",
    Administrative: "Administrative",
    NewDepartment: "New Department",
  },
  Settings: {
    ForwardEmails: "Forward Emails",
    Save: "Save",
    CustomerTicketEmails: "Customer ticket emails",
    CustomerTicketEmailsHint:
      "Email the customer when their ticket is created, answered, changes status, or is closed, and send a copy to the customer ticket recipients. Tickets kept between agents stay on the ticket templates.",
    CustomerTicketsRecipients: "Customer Tickets Recipients",
    FirewallRecipients: "Firewall Recipients",
    ItemsRecipients: "Items Recipients",
    ItemReminderRecipients: "Item Reminder Recipients",
    FtpRecipients: "FTP Recipients",
    SubscriptionsRecipients: "Subscriptions Recipients",
    TasksRecipients: "Tasks Recipients",
    TicketsRecipients: "Tickets Recipients",
    TicketPrintRecipients: "Ticket Print Recipients",
    UsersRecipients: "Users Recipients",
    VouchersRecipients: "Vouchers Recipients",
    Enabled: "Enabled",
    Host: "Host",
    Username: "Username",
    Password: "Password",
    UploadPath: "Upload Path",
    UploadPathPlaceholder: "ex. /upload",
    Port: "Port",
    Secure: "Secure?",
    Messages: "Messages",
    Forwards: "Forwards",
    Mail: "Mail",
    ConfigurationName: "Configuration Name",
    EmailSubject: "Email Subject",
    SubjectPlaceholder: "ex. New Ticket [${ticket.id}]",
    FromEmail: "From Email Address",
    FromEmailPlaceholder: "Default",
    Forward: "Forward",
    ForwardPlaceholder: "Email received by the recipients forward list...",
    Direct: "Direct",
    DirectPlaceholder: "Email received by the targeted recipient...",
    AssistantID: "Assistant ID",
    APIKey: "API Key",
    OrganizationID: "Organization ID",
    Server: "Server",
    Database: "Database",
    Test: "Test",
    SMTPServerPlaceholder: "smtp.gmail.com",
    SecureConnection: "Secure Connection?",
    TestEmail: "Test Email",
    TestEmailPlaceholder: "john.doe@email.com",
    TestMessage: "Message to test",
    MessageTestHint:
      "Sends the message in the editor. Placeholders are filled with sample data, and the template does not need to be enabled.",
    PrintTemplates: "Print Templates",
    AvailableTemplates: "Available Templates",
    NoPrintTemplateFound: "No print template found",
    AddTemplate: "Add Template",
    View: "View",
    PeriodicInventorySync: "Periodic Inventory Sync",
    SyncInventory: "Sync Inventory",
    Warehouses: "Warehouses",
    NoWarehousesAdded: "No warehouses added",
    Settings: "Settings",
    General: "General",
    AddCity: "Add City",
    PrintTemplate: {
      Title: "Print Template",
      Body: "Customize the layout and format of printed documents, including headers, footers, and branding.",
    },
    Cities: {
      Title: "Cities",
      Body: "Manage the list of available cities for use throughout the application, such as in addresses or location-based filters.",
    },
    Branding: {
      Title: "Branding",
      Body: "Customize the look and feel of the application, including colors and branding.",
    },
    Security: {
      Title: "Security",
      Body: "Secure your system by controlling who has access.",
    },
    Logs: {
      Title: "Logs",
      Body: "Review a history of user actions and system events for auditing and troubleshooting.",
    },
    EmailSetup: "Email Setup",
    MailMessageConfiguration: {
      Title: "Mail Message Configuration",
      Body: "Define default subject lines, message bodies, and signatures for automated and manual email communications.",
    },
    EmailForwarding: {
      Title: "Email Forwarding",
      Body: "Configure rules for redirecting incoming emails to other addresses or departments for better workflow management.",
    },
    Integrations: "Integrations",
    SMTP: {
      Title: "SMTP",
      Body: "Set up outgoing email server settings including host, port, and credentials to enable email functionality.",
    },
    OpenAI: {
      Title: "OpenAI",
      Body: "Configure OpenAI API settings including Assistant ID, API key, and other required parameters to enable AI-powered features.",
    },
    FTP: {
      Title: "FTP",
      Body: "Configure FTP server access to upload, download, or sync files between your system and external storage.",
    },
    WebhooksAPI: {
      Title: "Webhooks & API",
      Body: "Configure webhooks and API access to enable external systems to send or receive data in real-time from the platform.",
    },
    Import: {
      Title: "Import",
      Body: "Automate synchronization of data across platforms",
    },
  },
  ImportSettings: {
    ImportConfiguration: "Import Configuration",
    Save: "Save",
    Model: "Model",
    AutoSync: "Auto Sync",
    KeyPath: "Key Path",
    TargetPath: "Target Path",
    Url: "Url",
    Headers: "Headers",
    Synchronize: "Synchronize",
  },
  TicketPrintTemplate: {
    TicketPrintTemplate: "Ticket Print Template",
    Add: "Add",
    Save: "Save",
    TemplateName: "Template Name",
    Fields: {
      Title: "Fields",
      Subtitle: "Select which fields to include in the print template.",
    },
    Body: "Body",
    Banner: "Banner",
    Title: "Title",
    TicketInfo: "Ticket Info",
    ID: "ID",
    Priority: "Priority",
    Department: "Department",
    Responses: "Responses",
    ContactInfo: "Contact Info",
    Company: "Company",
    Person: "Person",
    Phone: "Phone",
    Location: "Location",
    Assignees: "Assignees",
    ServiceCallSap: "Service Call (SAP)",
    CallID: "CallID",
    CompanyName: "Company Name",
    ContactName: "Contact Name",
    Task: "Task",
    Description: "Description",
    TaskAssignees: "Task Assignees",
    Comments: "Comments",
    Timelogs: "Timelogs",
    ItemsUsed: "Items Used",
    PrintTemplateControls: {
      Title: "Print Template Controls",
      Subtitle:
        "Adjust limits, visibility, and formatting for printed content.",
    },
    MaxResponses: "Max Responses",
    MaxTasks: "Max Tasks",
    ForwardEmails: "Forward Emails",
    CopyTemplate: "Copy Template",
    SignatureRequired: "Signature Required",
    Themes: {
      Title: "Themes",
      Subtitle:
        "Manage color schemes and styles to align with your brand identity or personal preferences.",
    },
    BackgroundColor: "Background Color",
    TextColor: "Text Color",
    SectionTitleColor: "Section TitleColor",
    DisplayTicketUser: "Display Ticket User",
    DisplayResponder: "Display Responder",
    TaskType: "Type",
    CreateTemplate: "Create Template",
  },
  User: {
    Users: "Users",
    Name: "Name",
    Edit: "Edit",
    Role: "Role",
    Email: "Email",
    EmailPlaceholder: "ex. john.doe@email.com",
    Username: "Username",
    FullName: "Full Name",
    Company: "Company",
    Phone: "Phone",
    NewPassword: "New Password",
    EmailConfirmation: "Email Confirmation (MFA)",
    OTP: "OTP (MFA)",
    Action: "Action",
    Delete: "Delete",
    NewUser: "New User",
    ExtRef: "External Ref.",
    ExtRefPlaceholder: "ex. EC33499...",
  },
  Logs: {
    Logs: "Logs",
    Date: "Date",
    Reference: "Reference",
    Ref: "Ref",
    User: "User",
    Model: "Model",
    Action: "Action",
  },
  SecurityPage: {
    FirewallRecords: "Firewall Records",
    Date: "Date",
    IP: "IP",
    Prefix: "Prefix Length",
    Type: "Type",
    Action: "Action",
    Delete: "Delete",
    NewRecord: "New Record",
  },
  StoragePage: {
    Rename: "Rename",
    Delete: "Delete",
    FTPStorage: "FTP Storage",
    NewFolder: "New Folder",
    Path: "Path",
    Search: "Search",
    Name: "Name",
    Download: "Download",
    DownloadConfirm: "Do you want to proceed downloading this file?",
    Date: "Date",
    Size: "Size",
    Unknown: "Unknown",
    Folder: "Folder",
    SymbolicLink: "Symbolic Link",
    NewFile: "New File",
    Edit: "Edit",
  },
  FormTemplate: {
    Submit: "Submit",
    Cancel: "Cancel",
  },
  ConfirmDialog: {
    Question: "Are you sure you want to proceed?",
    Cancel: "Cancel",
    Confirm: "Confirm",
  },
  SignatureInput: {
    Signature: "Signature",
    Sign: "Sign",
  },
  TicketPrintDialog: {
    PrintTicket: "Print Ticket",
    Save: "Save",
    SaveAndSend: "Save & Send",
    Name: "Name",
    Language: "Language",
    Template: "Template",
    Copy: "Copy",
    Preview: "Preview",
    OriginalPreview: "Original Preview",
    CopyPreview: "Copy Preview",
    Signatures: "Signatures",
    GiverSignature: "Giver Signature",
    ReceiverSignature: "Receiver Signature",
    SendToForwardedEmails: "Send to forwarded emails?",
    SendCopy: "Send Copy?",
    CopyEmail: "Copy Email",
  },
  TicketOptionsButton: {
    Print: "Print",
    PrintLog: "Print Log",
    Delete: "Delete",
  },
  TicketPrintLogsDialog: {
    PrintLogs: "Print Logs",
    Delete: "Delete",
    View: "View",
    NoPrintLogsFound: "No print logs found",
  },
  LanguageSwitcher: {
    Tooltip: "Click here to change your language",
    Language: "Language",
    English: "English",
    Turkish: "Turkish",
  },
  DataView: {
    Search: "Search {{topic}}...",
    Filters: "Filters",
    Add: "Add",
  },
  Enums: {
    Unassigned: "Unassigned",
    Roles: {
      User: "User",
      Agent: "Agent",
      Admin: "Admin",
    },
    RecordTypes: {
      Whitelist: "Whitelist",
      Blacklist: "Blacklist",
    },
    Priorities: {
      Low: "Low",
      Medium: "Medium",
      High: "High",
    },
    Statuses: {
      "Not reviewed": "Not reviewed",
      Incomplete: "Incomplete",
      "Pending confirmation": "Pending confirmation",
      Complete: "Complete",
    },
    ItemType: {
      Invoice: "Invoice",
      Delivery: "Delivery",
    },
    DatePeriod: {
      Day: "Day",
      Week: "Week",
      Month: "Month",
      Year: "Year",
    },
    DateIndicator: {
      Custom: "Custom",
      Last: "Last",
      This: "This",
    },
  },
  TextEditor: {
    TypeHere: "Type here...",
  },
  IntegrationSettingsPage: {
    Title: "Integration Settings",
  },
  ApiSettingsPage: {
    Apis: "APIs",
    ViewKey: "View Key",
    NewApi: "New API",
    Description: "Description",
    Enabled: "Enabled",
    Disabled: "Disabled",
    AssociatedUser: "Associated User",
  },
  CreateApiDialog: {
    CreateApi: "Create API",
    Description: "Description",
    DescriptionPlaceholder: "ex. My first API key",
    User: "User",
    SelectUserPlaceholder: "Select a user...",
    AllowedIps: "Allowed IPs",
    AllowedIpsPlaceholder: "ex. 192.168.1.1",
    Enabled: "Enabled",
  },
  EditApiDialog: {
    EditApi: "Edit API",
    Description: "Description",
    DescriptionPlaceholder: "ex. My first API key",
    User: "User",
    SelectUserPlaceholder: "Select a user...",
    AllowedIps: "Allowed IPs",
    AllowedIpsPlaceholder: "ex. 192.168.1.1",
    Enabled: "Enabled",
    ApiKey: "API Key",
    Copy: "Copy",
    Delete: "Delete",
  },
  Api: {
    Description: "Description",
    Enabled: "Enabled",
    Disabled: "Disabled",
    AssociatedUser: "Associated User",
    AllowedIps: "Allowed IPs",
    Key: "Key",
  },
  WebhookSettingsPage: {
    Webhooks: "Webhooks",
    NewWebhook: "New Webhook",
    Description: "Description",
    Url: "Url",
    Enabled: "Enabled",
    Disabled: "Disabled",
  },
  WebhookForm: {
    CreateWebhook: "Create Webhook",
    EditWebhook: "Edit Webhook",
    Description: "Description",
    DescriptionPlaceholder: "ex. My first webhook",
    Url: "Url",
    UrlPlaceholder: "ex. https://mywebhook.url/endpoint",
    Enabled: "Enabled",
    Delete: "Delete",
    ViewLogs: "View Logs",
    ViewConfigurations: "View Configurations",
  },
  WebhookEventSelect: {
    SelectEvent: "Select Event",
    TicketEvents: "Ticket Events",
    UserEvents: "User Events",
    DepartmentEvents: "Department Events",
    FileEvents: "File Events",
    TaskEvents: "Task Events",
    FirewallEvents: "Firewall Events",
    Ticket: {
      TicketCreated: "Ticket Created",
      TicketUpdated: "Ticket Updated",
      TicketDeleted: "Ticket Deleted",
      TicketResponseCreated: "Ticket Response Created",
      TicketResponseUpdated: "Ticket Response Updated",
      TicketResponseDeleted: "Ticket Response Deleted",
      TicketAssigneeAdded: "Ticket Assignee Added",
      TicketAssigneeRemoved: "Ticket Assignee Removed",
      TicketDetailsUpdated: "Ticket Details Updated",
    },
    User: {
      UserCreated: "User Created",
      UserRegistered: "User Registered",
      UserUpdated: "User Updated",
      UserDeleted: "User Deleted",
    },
    File: {
      FileUploaded: "File Uploaded",
      FileDeleted: "File Deleted",
      FileDirectoryCreated: "File Directory Created",
      FileDirectoryDeleted: "File Directory Deleted",
    },
    Task: {
      TaskCreated: "Task Created",
      TaskUpdated: "Task Updated",
      TaskDeleted: "Task Deleted",
      TaskTimelogCreated: "Task Timelog Created",
      TaskTimelogUpdated: "Task Timelog Updated",
      TaskTimelogDeleted: "Task Timelog Deleted",
      TaskUserAssigned: "Task User Assigned",
      TaskUserUnassigned: "Task User Unassigned",
      TaskProductsAdded: "Task Products Added",
      TaskProductsDeleted: "Task Products Deleted",
      TaskProductsSerialsUpdated: "Task Products Serials Updated",
      TaskStatusUpdated: "Task Status Updated",
    },
    Firewall: {
      FirewallRecordCreated: "Firewall Record Created",
      FirewallRecordUpdated: "Firewall Record Updated",
      FirewallRecordDeleted: "Firewall Record Deleted",
    },
    Department: {
      DepartmentCreated: "Department Created",
      DepartmentUpdated: "Department Updated",
      DepartmentDeleted: "Department Deleted",
    },
  },
  HttpHeaderList: {
    HttpHeaders: "HTTP Headers",
    AddHeader: "Add Header",
    HeaderName: "Header Name",
    HeaderValue: "Header Value",
  },
  WebhookLogs: {
    WebhookLogs: "Webhook Logs",
    Date: "Date",
    Url: "URL",
    ResponseCode: "Response Code",
    Payload: "Payload",
    ViewPayload: "View Payload",
    Status: "Status",
    Response: "Response",
  },
  Branding: {
    BrandingSettings: "Branding Settings",
    Branding: "Branding",
    ThemeColor: "Theme Color",
    Logo: "Logo",
    UploadLogo: "Upload Logo",
    Address: "Address",
    Email: "Email",
    MapEmbed: "Map Embed",
    Phone: "Phone",
    WhatsappLabel: "Whatsapp Label",
    WhatsappNumber: "Whatsapp Number",
    FacebookLabel: "Facebook Label",
    FacebookLink: "Facebook Link",
    InstagramLabel: "Instagram Label",
    InstagramLink: "Instagram Link",
    LinkedinLabel: "Linkedin Label",
    LinkedinLink: "Linkedin Link",
    WebsiteLabel: "Website Label",
    WebsiteLink: "Website Link",
    XLabel: "X (Twitter) Label",
    XLink: "X (Twitter) Link",
    YoutubeLabel: "Youtube Label",
    YoutubeLink: "Youtube Link",
    Image: "Image",
    Link: "Link",
    Name: "Name",
    Shortname: "Short name",
    Domain: "Domain",
    LogoLink: "Logo Link",
    Contacts: "Contacts",
    Links: "Links",
    Favicon: "Favicon",
    Title: "Title",
    Description: "Description",
    WhatWeDo: "What we do?",
  },
  FaviconInput: {
    Change: "Change",
    ClickToUpload: "Click here to upload your icon",
    ImgSupported: "Supports: ICO",
  },
  FilterViews: {
    FilterView: "Filter View",
    DefaultView: "Default view",
    Save: "Save",
    SaveView: "Save View",
    New: "New",
    Delete: "Delete",
    Name: "Name",
  },
};
